import {Panes, TextField} from '@management-ui/core';
import React from 'react';
import YesNoField from '../../../../components/YesNoField';

const Fields = ({keyPair = {}, prefix = ''}) => (
  <Panes
    entity={keyPair}
    prefix={prefix}
    panes={[
      {
        title: 'Access Key Details',
        fields: [
          <TextField
            name="title"
            prefix={prefix}
            label="Title"
            rules={{required: 'Please enter a title'}}
          />
        ]
      },
      {
        title: 'Settings',
        fields: [
          <YesNoField
            name="is_active"
            prefix={prefix}
            label="Is Active?"
          />
        ]
      }
    ]}
    title={null}
  />
);

export default Fields;
